<template>
    <div class="body indexFlex home-page">
        <div class="home-header">
            <div class="home-header-bar">
                <span class="home-header-title">我的工时概览</span>
                <div class="hour-overview-ranges">
                    <span v-for="item in overviewRanges" :key="item.key"
                        :class="{ active: overviewRange === item.key }"
                        @click="changeOverviewRange(item.key)">{{ item.label }}</span>
                </div>
            </div>
        </div>

        <div class="indexFlex1 home-body">
            <div class="stack-card hour-overview" v-if="overview">
                <div class="hour-overview-grid">
                    <div class="hour-overview-item" @click="openOverview('total')">
                        <div class="hour-overview-value is-total">{{ formatHour(overview.totalHours) }}<span class="hour-overview-unit">h</span></div>
                        <div class="hour-overview-label">总工时</div>
                    </div>
                    <div class="hour-overview-item" @click="openOverview('overtime')">
                        <div class="hour-overview-value is-overtime"
                            :class="{ 'is-zero': !isPositive(overview.overtimeHours) }">{{ formatHour(overview.overtimeHours) }}<span class="hour-overview-unit">h</span></div>
                        <div class="hour-overview-label">加班工时</div>
                    </div>
                    <div class="hour-overview-item" @click="openOverview('project')">
                        <div class="hour-overview-value is-project"
                            :class="{ 'is-zero': !isPositive(overview.projectCount) }">{{ overview.projectCount }}<span class="hour-overview-unit">个</span></div>
                        <div class="hour-overview-label">参与项目</div>
                    </div>
                    <div class="hour-overview-item" @click="openOverview('rejected')">
                        <div class="hour-overview-value is-rejected"
                            :class="{ 'is-zero': !isPositive(overview.rejectedHours) }">{{ formatHour(overview.rejectedHours) }}<span class="hour-overview-unit">h</span></div>
                        <div class="hour-overview-label">驳回工时</div>
                    </div>
                    <div class="hour-overview-item" @click="openOverview('pending')">
                        <div class="hour-overview-value is-pending"
                            :class="{ 'is-zero': !isPositive(overview.pendingHours) }">{{ formatHour(overview.pendingHours) }}<span class="hour-overview-unit">h</span></div>
                        <div class="hour-overview-label">待提交</div>
                    </div>
                    <div class="hour-overview-item" @click="openOverview('miss')">
                        <div class="hour-overview-value is-miss"
                            :class="{ 'is-zero': !isPositive(overview.missCount) }">{{ overview.missCount }}<span class="hour-overview-unit">天</span></div>
                        <div class="hour-overview-label">存在漏填</div>
                    </div>
                </div>
            </div>

            <div class="stack-card func-card">
                <div class="func-head">
                    <span class="card-title"><i class="title-bar"></i>全部功能</span>
                    <span class="func-count">({{ routers.length }} 项)</span>
                </div>
                <van-grid :column-num="4" :border="false">
                    <van-grid-item v-for="(item,index) in routers" :key="index" :icon="item.icon" :text="item.name"
                    :info="(item.name=='消息记录'&&unreadNum>0)?unreadNum:''"
                    :to="item.url" @click="pfdClick(item)">
                    </van-grid-item>
                </van-grid>
            </div>
            <div  v-if="this.user && this.user.companyId == 7">
            <div class="stack-card voice-entry"  @click="openVoiceFill">
                <div class="voice-entry-card">
                    <div class="voice-icon-wrap">
                        <svg class="voice-entry-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path fill="currentColor" d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.72V21h2v-3.28A7 7 0 0 0 19 11h-2z"/>
                        </svg>
                    </div>
                    <div class="voice-entry-text">点击开始AI语音快捷填报工时</div>
                    </div>
            </div>
            <div class="voice-entry-tip">例如说出：昨天智能穿戴眼镜项目上投入了6小时，进行了眼镜结构设计工作；下午在电信全网通项目上投入了2小时，进行基础通信模块开发。晚上加班3小时，在万达游戏项目上进行方案设计讨论。</div>
            </div>
        </div>
        <div v-if="isCorpWX" class="kefu" @click="tokefu"><img src="../../assets/icon/kefu.png" alt=""></div>
        <Footer ref="child" :key="key"></Footer>
    </div>
</template>
<script>
    import Footer from "@/components/Footer";
    import Vue from "vue";
    import { ImagePreview } from "vant";
    Vue.use(ImagePreview);
    export default {
        data() {
            return {
                yuzhongCompId: 3385,
                isCorpWX:false,
                isWX:false,
                user: null,
                unreadNum:0,
                routers: [],
                key: 0,
                isSyncData: false,
                overview: null,
                overviewRange: "week",
                overviewRanges: [
                    { key: "today", label: "今日" },
                    { key: "week", label: "本周" },
                    { key: "month", label: "本月" },
                    { key: "lastMonth", label: "上月" }
                ],
                jobNumberCheckCompanyId: [936], // 定制需求，需要完善工号的公司id
            };
        },
        created() {
            if(localStorage.userInfo) {
                this.user = JSON.parse(localStorage.userInfo)
                // 是否为钉钉同步
                this.isSyncData = this.user.timeType.syncDingding || this.user.timeType.syncFanwei;
            } 
        },
        mounted() {
            //有错误信息，优先跳转到登录页面去
            if(window.location.href.indexOf('errorMsg') != '-1') {
                this.$router.push("/login");
            }
            var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf("wxwork") > 0) {
                this.isCorpWX = true;
            } else if (ua.indexOf("micromessenger") > 0) {
                this.isWX = true;
            }
            let that = this;
            //企业微信或个人微信是从后台授权后跳转过来的
            if (this.isCorpWX || this.isWX) {
                //后台自动授权登录的用户
                if(window.location.href.indexOf('userId') != '-1') {
                    let href = window.location.href;
                    var loginUserId = href.substring(href.indexOf("userId=")+"userId=".length);
                    if (loginUserId.includes('#/')) {
                        loginUserId = loginUserId.substring(0, loginUserId.indexOf('#/'));
                    }
                    that.getAccountInfo(loginUserId)
                } else {
                    //存在一部分用户，没有绑定企业微信，进来后跳到登录页面，登录页面输入账号密码进来后不带userId
                    if (this.user) {
                        that.getAccountInfo(that.user.id);
                    } else {
                        that.$router.push("/login");
                    }
                }
            } else {
                //其他情况，刷新用户信息
                if (localStorage.userInfo != null && localStorage.userInfo != 'undefined') {
                    that.user = JSON.parse(localStorage.userInfo);
                    that.getAccountInfo(that.user.id);
                } else{
                    //无用户信息，跳到登录页面去
                    this.$router.push("/login");
                }
            }
            if (this.user) {
                let userss = this.user;
                if(userss.isMobFirstLogin == 1 && userss.createTime[0] > '2022' && userss.roleName == '超级管理员') {
                    // 第一次登陆显示
                    this.previewPicture()
                }
            }

            // 检查是否有工号
            const { companyId, jobNumber, userNameNeedTranslate, name, dingdingUserid } = this.user
            if(this.jobNumberCheckCompanyId.includes(companyId) && !jobNumber) {
                this.$router.push({
                    path: '/editPerfect',
                    query: {
                        showjobNumber: 'true'
                    }
                });
            }

            // 检查是否需要完成姓名
            if(userNameNeedTranslate == 0 && (name == dingdingUserid)) {
                this.$router.push({
                    path: '/editPerfect',
                    query: {
                        showjobNumber: 'false'
                    }
                });
            }

            if(this.user.dingdingUserid) {
                this.setDDOpenData()
            }
        },
        components: {
            Footer
        },
        methods: {
            setDDOpenData() {
                const ddUrl = new URL(window.location.href);
                const ddCorpid = ddUrl.searchParams.get("corpid") || ''
                let ddOpenDataInit = window.DTOpenData.init(ddCorpid)
                console.log(ddOpenDataInit, '<=== 钉钉执行 window.DTOpenData.init(ddCorpid) 的判断')
                if (ddOpenDataInit) {
                    setTimeout(() => {
                        console.log('<==== 执行 window.DTOpenData.update(document.querySelectorAll(dt-open-data))')
                        window.DTOpenData.update(document.querySelectorAll('dt-open-data'));
                    }, 300)
                }else {
                    console.log('钉钉没有触发')
                }
            },
            pfdClick(item) {
                if(item.name == '使用说明') {
                    let url = 'http://celiang.oss-cn-hangzhou.aliyuncs.com/measurement/2022-01/18/75it6phpocqYFV1642488558220118.pdf'
                    let name = '使用说明书'
                    // 将要传过去的值
                    this.previewPDF(url, name)
                }
            },
            // 预览pdf
            previewPDF(url, name) {
                this.$router.push({
                    path:  '/pdf',
                    query: {
                        url: '',
                        name: name
                    }
                })
            },
            // 图片预览
            previewPicture() {
                let that = this
                let arr = [
                    'https://mobworktime.ttkuaiban.com/upload/b9cf863819924106a65255ccffae446d.png',
                    'https://mobworktime.ttkuaiban.com/upload/65afcaed7ad84c51a309db69c888fe6c.png',
                    'https://mobworktime.ttkuaiban.com/upload/3452d33a68bb4092b04147e5482fd0e9.png',
                    'https://mobworktime.ttkuaiban.com/upload/af5b430f48b24b2683fb48a43deab98c.png',
                    'https://mobworktime.ttkuaiban.com/upload/b69779d86be44ef3a1d3585816fde5f3.png'
                ]
                ImagePreview({
                    images: arr,
                    startPosition: 0,
                    showIndicators: true,
                    closeable: true,
                    onClose() {
                        that.previewPictureClose()
                    },
                });
            },
            // 处理关闭事件
            previewPictureClose() {
                this.$axios.post("/user/mobSkipGuidance", {
                })
                .then(res => {
                    if(res.code == "ok") {
                       let userss = JSON.parse(localStorage.userInfo)
                       userss.isMobFirstLogin = 0
                       localStorage.userInfo = JSON.stringify(userss);
                    } 
                }).catch(err=> {this.$toast.clear();});
            },
            tokefu(){
                wx.invoke('openThirdAppServiceChat', {
                    }, function(res) {
                        console.log('invoke',res);
                        if (res.err_msg == "openThirdAppServiceChat:ok" || res.err_msg == "openThirdAppServiceChat:cancel") {
                        }else{
                            this.$toast.fail('请联系管理员添加客服');
                        }
                        
                    }
                );
            },
            // 模块
            getModule() {
                if(this.user.userNameNeedTranslate == '1'){
                    this.agentConfig()
                }

                if (this.user.company.packageEngineering == 1) {
                    this.routers.push(
                    {
                        name: '专业审核',
                        url: '/profession_review',
                        icon: 'todo-list-o'
                    });
                }
                var list = this.user.moduleList
                let jurisdictionNameList = this.user.functionList.map(item => item.name)
                for (var i in list) {
                    if(list[i].name == '工时报告') {
                        this.routers.push({name: '查看日报',url: '/calendar',icon: 'description'})
                        if(this.user.timeType.enableNewWeeklyfill != 1) { // 针对新版按周填报去掉填写日报
                            this.routers.push({name: '填写日报',url: '/edit',icon: 'edit'})
                        }
                        if (this.user.companyId != 3092 && this.user.timeType.type != 0) {
                            this.routers.push({name: '按周填报',url: '/weekEdit',icon: 'records'})
                        }
                        if(jurisdictionNameList.some(item => item == '代填日报')) {
                            this.routers.push({name: '代填日报',url: '/edit?substitute=true',icon: 'completed'})
                        }
                    }
                    if(list[i].name == '待办任务') {
                        this.routers.push({
                            name: '待办任务',
                            url: '/task',
                            icon: 'coupon-o'
                        });
                    }
                    if(list[i].name == '项目报告审核') {
                        this.routers.push({name: '项目报告审核',url: '/review',icon: 'todo-list-o'})
                    }
                    if(list[i].name == '项目管理') {
                        this.routers.push({name: '项目管理',url: '/project',icon: 'label-o'})
                    }
                    if(list[i].name == '导入日报审核') {
                        this.routers.push({name: '导入日报审核',url: '/audit',icon: 'completed'})
                    }

                    if(!this.isSyncData) {
                        if(list[i].name == '请假管理') {
                            this.routers.push({name: '请假管理',url: '/applyLeave',icon: 'notes-o'})
                            // this.routers.push({name: '请假审批',url: '/exaLeave',icon: 'completed'})
                            // this.routers.push({name: '出差管理',url: '/awayOffice',icon: 'completed'})
                        }

                        if(list[i].name == '出差管理') {
                            this.routers.push({name: '出差管理',url: '/awayOffice',icon: 'logistics'})
                        }
                    }
                    if(list[i].name == '加班管理') {
                        this.routers.push({name: '加班管理',url: '/overtime',icon: 'todo-list-o'})
                    }

                    if(list[i].name == '费用报销') {
                        this.routers.push({
                            name: '费用报销',
                            url: '/expense',
                            icon: 'balance-list-o'
                        });
                    }
                    
                    if(list[i].name == '设备管理') {
                        this.routers.push({
                            name: '设备管理',
                            url: '/useRegistration',
                            icon: 'label-o'
                        }, {
                            name: '设备使用记录',
                            url: '/usageHistory',
                            icon: 'label-o'
                        });
                    }
                }
                if (this.user.manageDeptId != 0 && this.user.company.packageEngineering == 1) {
                    this.routers.push(
                    {
                        name: '部门审核',
                        url: '/department_review',
                        icon: 'todo-list-o'
                    });
                }
                
                this.routers.push({
                                    name: '消息记录',
                                    url: '/msg',
                                    icon: 'todo-list-o',
                                    info: this.unreadNum
                                });
                
                // 针对超级管理员加使用说明
                if(this.user.roleName == '超级管理员') {
                    this.routers.push(
                    {
                        name: '使用说明',
                        // url: '/',
                        icon: 'todo-list-o'
                    });
                }

                if(this.user.companyId == 7536) {
                    this.routers.splice(2, 0, {
                        name: '扫码填报',
                        url: '/edit?scanTheCode=1',
                        icon: 'scan'
                    })
                }
                // 设备管理
                // if(this.user.companyId == 10) {
                //     this.routers.push({
                //         name: '设备管理',
                //         url: '/useRegistration',
                //         icon: 'label-o'
                //     }, {
                //         name: '设备使用记录',
                //         url: '/usageHistory',
                //         icon: 'label-o'
                //     });
                // }
            },

            // 获取企业微信参数
            agentConfig(){
                let curUrl = window.location.href.split('#')[0]
                this.$axios.post('/wxcorp/getCorpWXConfig',{
                    url: curUrl,
                    token: this.user.id
                }).then(res => {
                    if(res.code == 'ok'){
                        wx.config({
                            beta: true,
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: res.data.appid, // 必填，公众号的唯一标识 
                            timestamp: res.data.timestamp, // 必填，生成签名的时间戳 
                            nonceStr: res.data.noncestr, // 必填，生成签名的随机串 
                            signature: res.data.sign, // 必填，签名，见附录1 
                            jsApiList: ['chooseImage','previewImage','uploadImage','downloadImage','previewFile','getLocation','agentConfig'] 
                        })
                        let that = this
                        wx.ready(function(){
                        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                            that.$axios.post('/wxcorp/getCorpWXAgentConfig', {
                                url: curUrl,
                                token: that.user.id
                            }).then(res => {
                                if(res.code == 'ok'){
                                    wx.agentConfig({
                                        corpid: res.data.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
                                        agentid: res.data.agentid, // 必填，企业微信的应用id （e.g. 1000247）
                                        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                                        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                                        signature: res.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                                        jsApiList: ['selectExternalContact','openThirdAppServiceChat', 'openAppManage'], //必填，传入需要使用的接口名称
                                        success: function (result) {
                                            // console.log(result, '请求微信成功')
                                            // console.log(window, 'window')
                                            //  wx.agentConfig成功回调后，WWOpenData 才会注入到 window 对象上面
                                            window.WWOpenData.bind(document.querySelector('TranslationOpenDataText'))
                                            // that.kefuShow = true
                                        },
                                        fail: function (res) {
                                            // console.log('查看错误信息', res)
                                            if (res.errMsg.indexOf('function not exist') > -1) {
                                                alert('版本过低请升级')
                                            } else {
                                                // alert('agentConfig出错:'+res.errMsg);
                                            }
                                        },
                                    })
                                }
                            }).catch(err => {
                                if (err.errMsg.indexOf('function not exist') > -1) {
                                    alert('版本过低请升级')
                                }else {
                                    // alert(res.errMsg);
                                }
                            })
                        });
                        wx.error(function(res){
                            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            // alert('wxConfig发生异常:'+JSON.stringify(res));
                            // 企业第一次授权安装进入后会报not in reliable domain的错误，刷新后正常
                            location.reload();
                        });
                    } else {
                        // alert(''+res);
                    }
                }).catch(err => {
                    alert(err);
                })
            },

            //获取账户信息
            getAccountInfo(userId) {
                this.$axios.get('/user/loginByUserId', {params:{userId: userId}})
                .then(res => {
                    // console.log(res);
                    if (res.code == 'error') {
                        localStorage.errorMsg = res.msg;
                        //账号信息有问题，不能使用。
                        this.$router.push("/error");
                    } else {
                        localStorage.userInfo = JSON.stringify(res.data);
                        this.user = res.data;
                        this.$refs.child.dealWith()
                        this.key++
                        this.getModule()
                        this.getMessage();
                        this.loadOverview();
                        this.redirectIfNess();
                        this.$forceUpdate()
                        if (this.user.companyId == this.yuzhongCompId) {
                            //去掉按周填报
                            this.routers = this.routers.filter(r=>r.name != '按周填报');
                        } 
                        // this.bindIfNessary();
                    } 
                }).catch(err=> {
                    alert('err=' + err);
                });
            },
            redirectIfNess() {
                var href = window.location.href;
                if (href.indexOf('path') > 0) {
                    var path = href.split('path=')[1].split('&')[0];
                    if (path == 'expense' || path == 'task') {
                        this.$router.push(path);
                    }
                }
            },
            bindIfNessary() {
                let href = window.location.href;
                var requestUrl = "";
                if (this.isCorpWX && (this.user.corpwxUserid == null|| this.user.corpwxUserid == undefined || this.user.corpwxUserid == 'undefined')) {//优先检查企业微信环境
                    requestUrl = "/wxcorp/bindCorpWeiXin";
                } else if (this.isWX && (this.user.wxOpenid == null || this.user.wxOpenid == undefined || this.user.wxOpenid == 'undefined')) {
                    requestUrl = "/wechat/bindWeiXin";
                } 
                
                if (requestUrl.length > 0) {
                    // localStorage.openId = 'o1L3L5lOrOl3_UEJjONaoT2Rne1I';
                    //会自动跳转到首页
                    // let href = 'http://hq.tangusoft.com/?code=011Ptjgc2rx1eI09Irgc2Rvsgc2PtjgF&state=1#/index';
                    
                    if (href.includes("com/?code")) {  //url包括 com/?code 证明为从微信跳转回来的
                        var url = href; //vue自动在末尾加了 #/ 符号，截取去掉
                        var jingPosit = url.indexOf("com/") + 4; //获取域名结束的位置

                        // var urlLeft = url.substring(0, jingPosit);//url左侧部分
                        var urlRight = url.substring(jingPosit, url.length); //url右侧部分
                        // console.log('urlRight=' + urlRight);
                        // window.location = urlLeft + "#/home" + urlRight;//拼接跳转
                        //获取code
                        var code = urlRight.substring('?code='.length,urlRight.indexOf('#/index'));
                        if (code.indexOf('&state=1') > 0) {
                            code = code.substring(0, code.indexOf('&state=1'));
                        }

                        //调用后台接口，注册用户
                        // console.log('获取到code=='+code);

                        this.$axios.get(requestUrl, {params:{code:code, userId: this.user.id}})
                            .then(res => {
                                // console.log(res);
                                if (res == null) {
                                    this.$toast.fail('绑定失败');
                                } else if(res.errcode != null) {
                                    //报错了
                                    console.log(res.errmsg);
                                } else {
                                    //获取openId
                                    if (res.data != null && ((this.isWX && res.data.wxOpenid != undefined)
                                                || (this.isCorpWX && res.data.corpwxUserid != undefined))) {
                                        localStorage.userInfo = JSON.stringify(res.data);
                                        // console.log('绑定成功');
                                        this.user = res.data;
                                        window.location.href = '/#/my/center';
                                    }
                                }
                            }).catch(err=> {
                                alert('err=' + err);
                            });
                    }
                }
            },

            //获取消息
            getMessage() {
                this.$axios.post("/information/list", {
                })
                .then(res => {
                    if(res.code == "ok") {
                        var list = res.data;
                        this.unreadNum = list.filter(l=>l.checked==0).length;
                        // console.log(this.unreadNum);
                        
                    } 
                }).catch(err=> {this.$toast.clear();});
            },
            formatHour(value) {
                const num = Number(value || 0);
                return num.toFixed(1);
            },
            // 数值是否大于0，为0时数字弱化显示，避免无异常时满屏警示色
            isPositive(value) {
                return Number(value || 0) > 0;
            },
            changeOverviewRange(range) {
                if (this.overviewRange === range) {
                    return;
                }
                this.overviewRange = range;
                this.loadOverview();
            },
            loadOverview() {
                this.$axios.post("/report/getMyMonthOverview", { range: this.overviewRange })
                    .then(res => {
                        if (res.code == "ok") {
                            this.overview = res.data;
                        }
                    }).catch(() => {});
            },
            openVoiceFill() {
                if (!this.user || this.user.companyId != 7) {
                    return;
                }
                if (!this.isCorpWX) {
                    this.$toast('语音填报仅支持企业微信客户端');
                    return;
                }
                this.$router.push({ path: "/edit", query: { voice: "1" } });
            },
            openOverview(type) {
                if (!this.overview) {
                    return;
                }
                const month = this.overview.month;
                const range = this.overviewRange;
                if (type === "total" || type === "miss") {
                    this.$router.push({
                        path: "/calendar",
                        query: { month: month, date: this.overview.startDate }
                    });
                    return;
                }
                if (type === "project") {
                    this.$router.push({ path: "/project", query: { mine: "1" } });
                    return;
                }
                this.$router.push({ path: "/hourList", query: { month: month, range: range, filter: type } });
            },

        },
        activated(){
            this.getMessage()
            if (this.user) {
                this.loadOverview()
            }
        },
        
    };
</script>

<style lang="less" scoped>
    .home-page {
        background: #f2f4f7;
        min-height: 100vh;
        padding-bottom: 56px;
        box-sizing: border-box;
    }
    .indexFlex {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        .indexFlex1 {
            flex: 1;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
    .home-header {
        background: linear-gradient(165deg, #2b7cff 0%, #4a9bff 55%, #6eb0ff 100%);
        padding: calc(18px + env(safe-area-inset-top, 0px) + 28px) 14px 72px;
        position: relative;
        z-index: 1;
        &::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: -1px;
            height: 36px;
            background: radial-gradient(ellipse 120% 100% at 50% 100%, #f2f4f7 0%, #f2f4f7 55%, transparent 56%);
            pointer-events: none;
        }
    }
    .home-header-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding-top: 4px;
    }
    .home-header-title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        flex-shrink: 0;
        letter-spacing: 0.2px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    }
    .home-body {
        margin-top: -42px;
        padding: 0 14px 20px;
        position: relative;
        z-index: 2;
    }
    .stack-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 8px 24px rgba(43, 124, 255, 0.08);
        margin-bottom: 12px;
        overflow: hidden;
    }
    .hour-overview {
        border: 1px solid rgba(255, 255, 255, 0.6);
    }
    .hour-overview-ranges {
        display: flex;
        align-items: center;
        background: rgba(255, 255, 255, 0.96);
        border-radius: 18px;
        padding: 3px;
        height: 34px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        span {
            margin-left: 0;
            padding: 0 10px;
            font-size: 12px;
            color: #667085;
            height: 28px;
            line-height: 28px;
            border-radius: 14px;
            position: relative;
            transition: all 0.2s ease;
        }
        span.active {
            color: #2b7cff;
            font-weight: 600;
            background: rgba(43, 124, 255, 0.1);
        }
        span.active::after {
            display: none;
        }
    }
    .hour-overview-grid {
        display: flex;
        flex-wrap: wrap;
        padding: 6px 4px 8px;
    }
    .hour-overview-item {
        width: 33.33%;
        text-align: center;
        padding: 14px 4px;
        box-sizing: border-box;
        border-radius: 10px;
        transition: background 0.15s ease;
        &:active {
            background: #f5f8ff;
        }
    }
    .hour-overview-value {
        color: #1f2937;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: -0.2px;
        // 单位（h / 个 / 天）比数字小一号，弱化显示
        .hour-overview-unit {
            margin-left: 2px;
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0;
        }
        // 不同含义的数字用颜色区分
        &.is-total {
            color: #2b7cff; // 总工时-主题蓝
        }
        &.is-overtime {
            color: #ff8b26; // 加班工时-橙色
        }
        &.is-project {
            color: #12b886; // 参与项目-绿色
        }
        &.is-rejected {
            color: #f5222d; // 驳回工时-红色
        }
        &.is-pending {
            color: #faad14; // 待提交-黄色
        }
        &.is-miss {
            color: #e4393c; // 存在漏填-警示红
        }
        // 数值为0时不需要强调，统一回落为浅灰
        &.is-zero {
            color: #c0c6d0;
        }
    }
    .hour-overview-label {
        margin-top: 6px;
        color: #8a94a6;
        font-size: 12px;
    }
    .card-title {
        display: inline-flex;
        align-items: center;
        font-size: 15px;
        font-weight: 600;
        color: #1f2937;
    }
    .title-bar {
        width: 3px;
        height: 14px;
        background: linear-gradient(180deg, #2b7cff, #6eb0ff);
        border-radius: 2px;
        margin-right: 8px;
        display: inline-block;
    }
    .func-card {
        padding-bottom: 6px;
        /deep/ .van-grid-item__content {
            padding: 12px 4px 10px;
            background: transparent;
        }
        // 小图标统一加圆角纯色背景，扁平风格、无阴影
        /deep/ .van-grid-item__icon {
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            font-size: 22px;
            color: #fff;
            border-radius: 7px;
            background: #2b7cff;
            transition: background 0.18s ease;
        }
        /deep/ .van-grid-item__content:active .van-grid-item__icon {
            background: #1f66df;
        }
        /deep/ .van-grid-item__text {
            color: #4a5568;
            font-size: 12px;
            margin-top: 9px;
            line-height: 1.2;
        }
        // 未读消息角标贴合圆角色块的右上角
        /deep/ .van-grid-item__icon .van-info {
            top: 1px;
            right: 1px;
            border: 2px solid #fff;
        }
    }
    .func-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 14px 6px;
    }
    .func-count {
        font-size: 12px;
        color: #99a1ad;
    }
    .voice-entry {
        margin-bottom: 12px;
    }
    .voice-entry-card {
        padding: 20px 16px 18px;
        text-align: center;
    }
    .voice-icon-wrap {
        width: 48px;
        height: 48px;
        margin: 0 auto;
        border-radius: 14px;
        background: linear-gradient(145deg, #eaf3ff, #d6e8ff);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .voice-entry-icon {
        width: 26px;
        height: 26px;
        color: #2b7cff;
        display: block;
    }
    .voice-entry-text {
        margin-top: 10px;
        color: #1f2937;
        font-size: 14px;
        font-weight: 600;
    }
    .voice-entry-tip {
        margin-top: 10px;
        padding: 0 4px;
        color: #99a1ad;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.6;
        text-align: left;
    }
    .voice-entry-sub {
        margin-top: 4px;
        color: #99a1ad;
        font-size: 12px;
    }
    .body {
        height: calc(100vh - 50px);
        position: relative;
    }
    .kefu{
        position: fixed;
        right: 24px;
        bottom: 110px;
        width: 44px;
        height: 44px;
        background-color: #fff;
        z-index: 1000;
        border-radius: 50%;
        box-shadow: 0 6px 16px rgba(43, 124, 255, 0.18);
        img{
            margin: 8px;
            width: 28px;
            height: 28px;
        }
    }
    .tip {
        width: 100%;
        font-size: 12px;
        color: #99a1ad;
        margin-top: 4px;
        text-align: center;
        line-height: 18px;
        padding: 0 8px 8px;
        box-sizing: border-box;
    }
</style>
